export const CHANGELOG = [
  {
    version: '0.30.4',
    date: '2026-08-04',
    changes: [
      'Movimentos: aba Grupos ganhou associação rápida para Famílias sem grupo e Missionários sem grupo, com busca, ordenação, seleção múltipla por checkbox e associação em lote ao grupo escolhido.',
      'Movimentos: modais de associação rápida passaram a usar o mesmo padrão visual das tabelas principais, com borda, cabeçalho cinza, scroll horizontal, ação fixa e coluna Pessoas removida de Famílias sem grupo.',
      'Movimentos: tabelas de Famílias, Missionários e Grupos agora têm cabeçalhos ordenáveis; Famílias recebeu coluna Complemento, filtro Endereço incompleto, Endereços duplicados, Telefones inválidos e Famílias que participarão como missionário.',
      'Movimentos: tabela de Grupos recebeu coluna Missionários total, somando Anfitriões e Apoio, além de rótulos ajustados para Igreja, Anfitriões e Apoio.',
      'Movimentos: cadastro admin e público de missionários agora aceita Outra comum/igreja, com referência manual opcional e exibição separada para missionários de outra comum/igreja.',
      'Movimentos: perguntas personalizadas Sim/Não agora salvam o valor negativo como “não” com acento em famílias, missionários e visitas, mantendo compatibilidade com respostas antigas sem acento.',
    ],
  },
  {
    version: '0.30.3',
    date: '2026-07-29',
    changes: [
      'Movimentos: abertura de movimentos grandes ficou mais rápida; o Dashboard carrega primeiro e Famílias, Missionários e Grupos carregam sob demanda ao abrir cada aba.',
      'Movimentos: Dashboard ganhou novas métricas de relação visitas/missionários, grupos necessários, média do movimento, Sobrecarga/Equilibrado e missionários por configuração.',
      'Movimentos: importação Excel agora associa igreja por Casa de Oração e Código da igreja, habilitando automaticamente igrejas existentes no movimento quando necessário.',
      'Movimentos: importação de Famílias permite endereço sem número, marcando o alerta para correção posterior sem bloquear a importação.',
      'Movimentos: contador de Famílias no Dashboard foi corrigido para mostrar o total real antes mesmo de carregar a aba Famílias.',
      'Movimentos: cadastros internos de Famílias e Missionários não são mais bloqueados pelo prazo do link público; apenas movimentos encerrados bloqueiam alterações.',
    ],
  },
  {
    version: '0.30.2',
    date: '2026-07-28',
    changes: [
      'Movimentos: importação Excel de Famílias e Missionários agora aceita arquivos .xls além de .xlsx.',
      'Movimentos: preview de importação foi validado para arquivos legados .xls, mantendo criação/atualização por telefone dentro do mesmo movimento.',
      'Movimentos: importação de Famílias preserva latitude e longitude quando essas colunas estão presentes na planilha.',
      'Movimentos: botões de upload de Famílias e Missionários agora mostram loading no próprio botão enquanto a planilha é carregada.',
    ],
  },
  {
    version: '0.30.1',
    date: '2026-07-25',
    changes: [
      'Acessos: adicionada tela pós-login para usuários com múltiplos contextos escolherem entre Gestor Global, Minha Igreja e Painel dos Movimentos.',
      'Acessos: opção “Lembrar minha escolha” mantém o redirecionamento automático no login, mas o novo botão Acessos sempre abre a tela de escolha novamente.',
      'Acessos: botão apenas ícone foi adicionado no topo dos painéis Admin, Gestor, Auxiliar, EBI e Movimentos para alternar rapidamente de contexto.',
      'Acessos: tela de escolha foi refinada em fundo claro no padrão dos portais, sem busca, com cards espaçados, ícones azuis do tema e hover mais sutil.',
      'Movimentos: cadastrar coordenador com e-mail já existente agora concede acesso adicional ao usuário existente, sem criar duplicidade nem trocar seu papel principal.',
      'Movimentos: cadastro público de famílias agora alerta quando telefone já existe no mesmo movimento, mostra dados da família encontrada e permite continuar apenas após confirmação.',
      'Movimentos: link público de famílias agora exige celular brasileiro válido com DDD no padrão (11) 99999-9999, rejeitando números incompletos ou fora da máscara.',
      'Movimentos: Famílias e Missionários agora possuem importação Excel com prévia, confirmação e atualização automática por telefone dentro do mesmo movimento.',
      'Movimentos: exportação/importação de Famílias agora preserva latitude e longitude; arquivos exportados seguem o padrão m-familias ou m-missionarios com data e hora.',
      'Movimentos: Famílias, Missionários e Grupos agora permitem seleção de itens e ações em massa com controle inline e confirmação.',
      'Movimentos: abas Famílias e Missionários ganharam card gráfico contextual por igreja participante acima da listagem.',
      'Recitativos: restaurada compatibilidade com filas antigas, convertendo automaticamente dados legados de Filas para funções de Recitativo sem duplicar registros.',
      'Recitativos: igrejas com dados antigos voltam a visualizar filas e sugestões de revezamento no fluxo atual de escalas.',
    ],
  },
  {
    version: '0.30.0',
    date: '2026-07-07',
    changes: [
      'Movimentos: Portal do Missionário substituiu o Portal do Líder, com acesso individual por missionário, nome do missionário no header e estrela para líderes.',
      'Movimentos: Portal do Missionário agora limita famílias e missionários à própria comum/igreja do missionário logado, inclusive em listagem, edição, exclusão e registro de visitas.',
      'Movimentos: líderes podem cadastrar, editar e excluir famílias e missionários da própria comum pelo portal mobile, com formulários fullscreen e drawers de seleção roláveis.',
      'Movimentos: permissões de missionários foram simplificadas para níveis Missionário, Líder e Administrador, com cards explicativos e seleção visual no Gestor e no Portal.',
      'Movimentos: nova permissão Administrador controla quem pode conceder/remover liderança de outros missionários; backend bloqueia tentativas sem permissão.',
      'Movimentos: cadastro de missionário no portal ganhou seletor de Comum/Igreja em drawer, opção Outra, campo limpo ao selecionar Outra e associação obrigatória à igreja do missionário logado.',
      'Movimentos: listagem de famílias no portal foi agrupada por bairro em cards cinza sempre expandidos; listagem de missionários ganhou badge Líder e botão de copiar acesso visível apenas para líderes.',
      'Movimentos Gestor: wizard e detalhe passaram a tratar datas/horas no padrão Brasil/São Paulo, convertendo corretamente entre horário local e UTC.',
      'Movimentos Gestor: Dashboard do detalhe usa gráficos responsivos, atualiza dados ao trocar submenus e exibe gráficos para perguntas personalizadas de escolha em Visitas, Famílias e Missionários.',
      'Movimentos: opções de perguntas personalizadas de escolha agora usam ponto e vírgula como separador, mantendo compatibilidade com dados antigos separados por vírgula.',
      'Cadastro público: fluxo após informar WhatsApp ficou mais resiliente para novos cadastros e cadastros existentes com campos nulos, evitando tela branca/error boundary.',
    ],
  },
  {
    version: '0.29.1',
    date: '2026-07-04',
    changes: [
      'Movimentos: Portal do Líder redesenhado em mobile com Dashboard, Visitas, Missionários, Atualizar no rodapé e logout pequeno no header.',
      'Movimentos: detalhe da visita separado em cards de endereço, status e ações; endereço exibido em Logradouro, Bairro - Cidade - UF e CEP.',
      'Movimentos: status Realizada/Não realizada agora exige modal obrigatório de Receptividade ou Motivo antes de salvar, evitando registros incompletos.',
      'Movimentos: Dashboard do Portal ganhou gráficos de Status das visitas, Receptividade e Motivo da não realização, exibidos apenas quando houver dados correspondentes.',
      'Movimentos: perguntas personalizadas no Portal usam modais próprios para Sim/Não, Seleção única e Múltipla seleção; múltipla seleção exibe os itens escolhidos por nome.',
      'Movimentos: cadastro/edição de família ganhou Limite máximo de pessoas com toggle e campo compacto; o limite aparece no Portal do Líder quando habilitado.',
      'Movimentos: campo Ponto de referência removido; Complemento agora concentra complemento e referências.',
      'Movimentos Gestor: listagem ganhou exclusão de movimento com confirmação e cascata para famílias, missionários e grupos relacionados.',
      'Configurações > Filas/Recitativos: corrigida perda de auxiliares selecionados ao salvar; seleções rápidas não sobrescrevem mais escolhas anteriores.',
      'Configurações > Filas/Recitativos: auxiliares atribuídos não são mais removidos automaticamente ao abrir/listar funções, reduzindo falsos positivos de “auxiliar inativo”.',
      'Configurações > Tipos de Evento: mensagens automáticas de WhatsApp ganharam a variável {escala_evento}, que insere a escala agrupada por pessoa em Meninos/Meninas, considerando recitativos e serviços.',
      'Eventos > Gerir Escala: adicionada reanálise de critérios com prévia antes de aplicar alterações na escala.',
      'Eventos: modal de evento ganhou botão para copiar a mensagem WhatsApp formatada do tipo de evento, incluindo dados do evento e escala quando configurada.',
      'WhatsApp: variável {escala_evento} agora inclui corretamente filas/recitativos exibidos em Gerir Escala, mesmo quando vêm das atribuições fixas das filas.',
      'WhatsApp: variável {escala_evento} agora considera substituições por nome da função, incluindo pessoas que aparecem em Gerir Escala via presença/substituição.',
      'WhatsApp: escala agrupada por pessoa agora lista filas/recitativos antes dos demais serviços e o botão de copiar mensagem ficou visualmente neutro.',
      'Reuniões: corrigido horário das pautas que podia aparecer adiantado em 3h; novas pautas e exibição de timestamps agora respeitam America/Sao_Paulo.',
      'Cadastro público: ajustes mobile para evitar tela branca percebida ao avançar etapas, removendo animações problemáticas, alinhando o card ao topo e adicionando fallback de erro.',
    ],
  },
  {
    version: '0.29.0',
    date: '2026-07-01',
    changes: [
      'EBI Histórias: fluxo de status ficou linear — Recebida ⇄ Corrigida ⇄ Aprovada — com botões de avançar/voltar e confirmação antes de cada mudança.',
      'EBI Rich Text: nos campos de história, fundamento, objetivo, atividades e glossário, Enter agora preserva quebra de linha na impressão como Shift+Enter; Enter duplo mantém linha em branco.',
      'EBI Impressão: removido o texto “Preparando impressão...”, preservadas quebras de linha do HTML rico e reforçadas bordas em PDFs com múltiplas páginas.',
      'EBI Acompanhamento Público: modal de detalhes ficou mais limpo, com wizard Enviada → Corrigida → Aprovada, checks por etapa e arquivos ocultos quando não houver anexos.',
      'EBI Anexos: arquivos enviados pelo link público agora abrem pela tela de edição usando endpoint autenticado por história/anexo, evitando links brutos de upload.',
      'EBI IA: prompt personalizado ficou temporariamente inativo; a análise agora usa um prompt fixo do sistema com 17 critérios para título, referência, história, fundamento, atividades/anexos e objetivo.',
      'EBI IA: novos guardrails automáticos revisam todos os critérios após a IA, impedindo aprovação indevida em referência inválida, título em caixa alta, ausência de “Deus seja louvado”, linguagem neutra, termos pesados, dramatizações e outros pontos sensíveis.',
      'EBI IA: quando houver sugestão objetiva para título, referência, fundamento ou objetivo, a tela de edição exibe botão “Aplicar correção” com modal de confirmação antes de substituir o campo.',
      'EBI WhatsApp: em Configurações > Geral, agora é possível configurar avisos automáticos para histórias enviadas, corrigidas e aprovadas, com números e mensagens separados por evento.',
      'EBI WhatsApp: os avisos usam Evolution API, respeitam conexão ativa e enviam em background com delay aleatório de 15 a 40 segundos entre destinatários; cada mensagem também ganhou botão “Enviar teste”.',
      'EBI WhatsApp: o formulário público ganhou Número de WhatsApp, a variável {whatsapp} pode ser usada como destinatário dinâmico e as mensagens agora suportam {link_ebi} e {link_acompanhamento}.',
      'EBI Configurações: aba de alertas foi renomeada para Avisos, com nova aba Geral para atualizar automaticamente e-mail/WhatsApp da Contadora Oficial com histórico De → Para.',
      'EBI Impressão: nome da página/PDF segue “EBI {igreja} - {Título} - YYMMDD” e a linha Colaboradoras exibe o grupo ao final.',
      'Complementos WhatsApp: corrigido o fluxo do Admin para ativar/desativar a instância Evolution, exibindo QR Code quando pronto e removendo a instância ao desativar.',
      'Cadastro público principal: corrigida tela branca ao preencher telefone em links legados /pessoas sem slug; erros estruturados agora são tratados sem quebrar a tela.',
    ],
  },
  {
    version: '0.28.0',
    date: '2026-06-20',
    changes: [
      'Batismos: importação em massa de igrejas/cooperadores, campos Data de Nascimento e Data de Apresentação para administradores e edição do registro do Gestor dentro das igrejas.',
      'Batismos: Google Places no cadastro de endereço, Google Geocoding na importação, importação parcial sem bloquear lote inteiro e máscaras automáticas de telefone.',
      'Batismos: seleção em massa, exclusão em massa, edição em massa da Comum com confirmação, tabela como visualização padrão e listagem mobile responsiva com ações por ícone.',
      'Batismos: impressão em modo Tabela/Paisagem, nome em negrito, título de PDF padronizado e resumo por faixa etária Até 12, 13 a 25 e +25 anos.',
      'Links públicos: igrejas novas agora geram slugs e links padrão para Cadastro, Perguntas, Visitas, Atualizar Dados e Agenda; botão Ver Página volta a aparecer em igrejas recém-criadas.',
      'Links públicos: padrão visual atualizado com ícone Home, gradiente claro, fonte Inter, textos #333333 e botões brancos com borda 2px/raio 15; botão Resetar configurações padrões usa modal próprio.',
      'Agenda pública: passou a respeitar as configurações visuais de Links para fundo, fonte, ícone e botões, alinhando o visual com as demais páginas públicas.',
      'Recitativos: nova função não exige seleção manual de filtro; Auxiliar de Jovens é aplicado automaticamente no frontend e backend.',
      'Recitativos: auxiliares inativos, sem acesso ou com usuário removido deixam de contar em pessoas atribuídas e são desvinculados automaticamente ao listar/salvar/inativar/desativar.',
      'Administradores: envio de nova senha temporária por SMS agora abre modal de confirmação no Admin e no Gestor; senhas temporárias foram padronizadas para 6 dígitos numéricos.',
      'Senha: removida a barra duplicada de força, mantendo apenas uma barra funcional com cor e largura dinâmica.',
      'Mobile Admin: botões de Tutorial, Notificações e Links foram movidos para dentro do menu, abaixo de Configurações e acima de Auditoria.',
    ],
  },
  {
    version: '0.27.0',
    date: '2026-06-09',
    changes: [
      'Autenticação: Google Login substituído por login com e-mail e senha, bcrypt, sessão por cookie e lockout após tentativas inválidas.',
      'Recuperação de senha: novo fluxo “Recuperar senha pelo celular” com modal, código SMS e redefinição por senha forte.',
      'Gestor: menu “Meu Acesso” permite atualizar nome, e-mail/login e celular de recuperação.',
      'Gestor: nova aba “Módulos” por igreja/tenant controla Perguntas, Solic. de Visitas, Votações, Reuniões, WhatsApp e Montagens.',
      'Admin/Auxiliar: módulos bloqueados pelo Gestor são ocultados e as APIs retornam bloqueio sem apagar dados existentes.',
      'Menu Admin: Dashboard voltou como primeiro item; Presença foi movida para Gestão; dropdown Gestão fecha ao clicar novamente ou fora.',
      'Menu Auxiliar: dropdown Gestão aplicado também no painel auxiliar.',
      'Pessoas: filtro “Usuários do Sistema” renomeado para “Usuários”; WhatsApp duplicado agora salva com aviso informando qual contato já possui o número.',
      'Montagens: novo módulo substitui visualmente Cestas Básicas, com data, cestas básicas, kits de higiene e valor em R$.',
      'Montagens: listagem com cards de totais, gráfico com três métricas por data, histórico responsivo, badges zerados ocultos e confirmação antes de excluir.',
      'Agenda Pública: link “Adicionar ao Google Agenda” normalizado com `cid` URL-encoded para calendários `@group.calendar.google.com`.',
      'Correções visuais: dropdown Gestão sem salto no hover, listagem Montagens compactada e gráfico oculto quando não há dados.',
    ],
  },
  {
    version: '0.26.2',
    date: '2026-05-12',
    changes: [
      'Eventos recorrentes: ao excluir, checkbox "Cancelar recorrência desta data" impede que o evento seja recriado automaticamente.',
      'Eventos recorrentes: datas excluídas registradas no tipo de evento e consultadas pela recorrência.',
      'Agenda Pública: corrigido bug de data — dia da semana e mês agora exibidos corretamente.',
    ],
  },
  {
    version: '0.26.1',
    date: '2026-04-07',
    changes: [
      'Engajamento: nova configuração em Geral — "Níveis de Engajamento" (Baixo/Médio/Alto) ou "Percentual (%)".',
      'Engajamento: modo Níveis agrupa pessoas por Alto, Médio e Baixo com badges coloridos (verde, âmbar, vermelho).',
      'Engajamento: no Admin, tooltip mostra o % real ao passar o rato; no Auxiliar, apenas o nível sem %.',
      'Engajamento: padrão é Níveis para evitar disputas entre auxiliares.',
      'Dashboard: cards "Top 10 Presença", "Menos Engajados" e "Nunca Compareceram" ocultos no modo Níveis.',
      'WhatsApp > Campanha: acumulação de destinatários de múltiplas fontes (Pessoas + vários Grupos) com deduplicação automática.',
      'WhatsApp > Campanha: card "Destinatários Selecionados" sempre visível com total, origem e botão remover.',
      'WhatsApp > Campanha: configurações de envio aleatórias — intervalo (X a Y segundos), pausa a cada (X a Y mensagens), duração (X a Y segundos).',
    ],
  },
  {
    version: '0.26.0',
    date: '2026-04-07',
    changes: [
      'Tipos de Evento: nova opção "Notificar via WhatsApp" — envia lembretes automáticos aos auxiliares antes dos eventos.',
      'Tipos de Evento: personalização da mensagem de notificação com variáveis dinâmicas ({nome_evento}, {data}, {hora}, {dia_semana}, {tempo}).',
      'Tipos de Evento: escolha flexível de quando notificar (1, 2, 3, 5 ou 7 dias antes).',
      'Tipos de Evento: todos os checkboxes substituídos por Switch (visual moderno).',
      'Eventos: ícone de notificação no campo Data/Hora com tooltip mostrando datas, destinatários e intervalos estimados.',
      'Backend: loop automático a cada 30 minutos verifica e envia notificações WhatsApp com delay aleatório (30-55s) entre mensagens.',
      'Presença: polling em tempo real (1s) para sincronização entre auxiliares.',
      'Presença: verificação de alteração recente (30s) com modal de confirmação.',
      'Eventos: campo "Nome do evento" aumentado para 50 caracteres.',
      'Eventos: campo "Descrição do evento" adicionado (textarea, opcional).',
      'Eventos: nome truncado com "..." na listagem da aba Presença.',
      'Relatórios > Filas de Recitativos: agrupamento por faixa etária com auxiliares, badge "Não batizado" (12+) e botão copiar.',
      'Relatórios > Filas: link WhatsApp no nome de cada pessoa.',
      'Cadastro público: botão copiar campos do formulário no canto superior direito.',
      'WhatsApp: verificação de conexão antes de criar campanha.',
    ],
  },
  {
    version: '0.25.2',
    date: '2026-03-31',
    changes: [
      'Presença: polling em tempo real (1s) — alterações de outros auxiliares aparecem instantaneamente.',
      'Presença: verificação de alteração recente (30s) — avisa se outro auxiliar acabou de alterar o status antes de executar.',
      'Eventos: campo "Nome do evento" aumentado para 50 caracteres.',
      'Eventos: novo campo "Descrição do evento" (textarea, opcional) no modal de criar/editar.',
      'Eventos: nome do evento com truncate (...) na listagem da aba Presença.',
      'Relatórios: novo relatório "Filas de Recitativos" — agrupamento por faixa etária com auxiliares designados.',
      'Relatórios > Filas: botão copiar no formato "X à Y anos - Auxiliar1 e Auxiliar2" + lista de pessoas.',
      'Relatórios > Filas: badge "Não batizado" para pessoas com 12+ anos, incluído na cópia.',
    ],
  },
  {
    version: '0.25.1',
    date: '2026-03-24',
    changes: [
      'WhatsApp: envio agora usa background task + polling (resolve timeout em campanhas grandes).',
      'WhatsApp: modal de confirmação antes de enviar com resumo de destinatários, tipo (Próprio/Pai/Mãe) e configurações.',
      'WhatsApp: modal de detalhes da campanha redesenhado com cards de estatísticas (Total, Enviados, Pendentes, Erros, % Concluído).',
      'WhatsApp: botão "Pausar Envio" substitui "Cancelar" no modal de progresso, com confirmação.',
      'WhatsApp: todas as ações (aprovar, pausar, cancelar, voltar rascunho, reenviar) pedem confirmação.',
      'WhatsApp: edição bloqueada em campanhas enviando, pausadas ou concluídas.',
      'Página Sobre atualizada com todas as funcionalidades atuais (18 módulos).',
    ],
  },
  {
    version: '0.25.0',
    date: '2026-03-24',
    changes: [
      'Analytics: novo módulo de rastreamento de acessos, cliques e conversões em todas as páginas públicas.',
      'Analytics: tracking automático via sendBeacon em Cadastro, Perguntas, Visitas, Agenda, Atualizar Dados e Linktree.',
      'Analytics: cliques individuais nos links do Linktree rastreados por link.',
      'Relatórios > Links: dashboard completo — cards resumo, gráfico de acessos (30 dias), dispositivos, fontes de acesso.',
      'Relatórios > Links: tabela de Desempenho por Link com cliques, únicos, conversões, taxa e 7 dias.',
      'Relatórios > Links: badge "externo" com tooltip para links sem página própria (ex: Instagram).',
      'Relatórios > Pessoas: seletor Todas / Auxiliares / Não Auxiliares.',
      'Relatórios > Tipo de Evento: seletor Presenças / Participantes no gráfico.',
      'Relatórios: submenu "Auxiliares" removido (integrado no seletor de Pessoas).',
      'Google Calendar: aniversários sincronizados automaticamente ao criar, editar, inativar ou excluir pessoas.',
      'Google Calendar: eventos públicos sincronizados automaticamente ao criar, editar ou excluir.',
      'Agenda Pública: toggle "Evento Público" adicionado à aba Solic. Visitas.',
      'Agenda Pública: link "Agenda" auto-criado ao abrir Configurações > Links.',
      'Configurações: submenu "Integrações" removido.',
      'Complementos: Google Calendar renomeado para "Habilitar Google Calendar" com descrição atualizada.',
    ],
  },
  {
    version: '0.24.0',
    date: '2026-03-24',
    changes: [
      'Eventos: toggle "Evento Público" com confirmação — visível na página pública de Agenda.',
      'Agenda Pública: nova página /agenda/{slug} com timeline vertical agrupada por data.',
      'Agenda Pública: botão "Adicionar ao Google Agenda" com validação de WhatsApp e registro de anotação.',
      'Agenda Pública: formulário de inscrição com máscara de telefone (XX) XXXXX-XXXX.',
      'Agenda Pública: título e descrição configuráveis via Configurações > Links.',
      'Google Calendar: agenda pública "RJM {Igreja} - Pública" criada automaticamente.',
      'Google Calendar: eventos públicos sincronizados ao criar, editar ou excluir.',
      'Google Calendar: aniversários sincronizados automaticamente ao criar, editar, inativar ou excluir pessoas.',
      'Complementos: Google Calendar renomeado para "Habilitar Google Calendar" com descrição atualizada.',
      'Relatórios > Pessoas: seletor Todas / Auxiliares / Não Auxiliares.',
      'Relatórios > Tipo de Evento: seletor Presenças / Participantes no gráfico.',
      'Relatórios: submenu "Auxiliares" removido (integrado no seletor de Pessoas).',
      'Configurações: submenu "Integrações" removido (gestão via Complementos).',
      'Pessoas: submenu "Incompletos" — lista pessoas com cadastro parcial (Admin e Auxiliar).',
    ],
  },
  {
    version: '0.23.2',
    date: '2026-03-22',
    changes: [
      'Pessoas: novo submenu "Incompletos" — lista pessoas cadastradas sem data de nascimento (cadastro rápido para presença).',
      'Dashboard Auxiliar > Pessoas: submenu "Incompletos" também disponível para auxiliares.',
      'WhatsApp > Complementos: toggle integrado com criação/exclusão automática de instância e QR Code.',
      'WhatsApp > Complementos: bolinha pulsante de status (verde/amarela/cinza) clicável para atualizar.',
      'WhatsApp > Complementos: modal de confirmação ao desativar com aviso de interrupção de envios.',
      'WhatsApp > Campanha: variáveis ocultas ao usar "Contatos de Grupo" com aviso explicativo.',
      'WhatsApp > Campanha: botão "Cadastrados" para selecionar apenas membros com cadastro no sistema.',
      'WhatsApp > Campanha: campo Gênero inicia vazio no cadastro rápido de pessoa, com validação.',
      'WhatsApp > Campanha: nome da instância inclui ID do usuário (igreja_usuario_id).',
    ],
  },
  {
    version: '0.23.1',
    date: '2026-03-21',
    changes: [
      'WhatsApp: envio de campanhas via Evolution API com progresso em tempo real (SSE).',
      'WhatsApp: seletor "Pessoas" / "Contatos de Grupo" — importar destinatários de grupos do WhatsApp.',
      'WhatsApp: busca de grupos com campo de pesquisa e listagem de membros com nomes cruzados.',
      'WhatsApp: cruzamento inteligente de números com cadastro (com e sem 9o dígito, com e sem código de país).',
      'WhatsApp: badge "Cadastrado" (verde) e "Associar" para membros não cadastrados.',
      'WhatsApp: modal "Associar Número a Pessoa" com busca, confirmação e registro em log de auditoria.',
      'WhatsApp: botão "+ Pessoa" no modal de associação — cadastro rápido com nome e WhatsApp pré-preenchidos.',
      'WhatsApp: botão "Convidar" — envia mensagem personalizada com link do formulário de cadastro via Evolution API.',
      'WhatsApp: números exibidos no formato (XX) XXXXX-XXXX com 9o dígito sempre presente.',
      'WhatsApp: Chrome Extension removida — envio agora é exclusivamente via Evolution API.',
      'Integrações: submenu movido para antes de Backup em Configurações, com header descritivo.',
      'Integrações: QR Code menor e mais escuro, título simplificado para "WhatsApp".',
      'Integrações: configuração global (Gestor) separada da gestão de instância (Admin por igreja).',
    ],
  },
  {
    version: '0.23.0',
    date: '2026-03-17',
    changes: [
      'Novo módulo: Integrações (Configurações > Integrações) — integração com Evolution API para envio de mensagens via WhatsApp.',
      'Evolution API: configuração de URL do servidor e API Key direto pelo app.',
      'Evolution API: criar instância WhatsApp com nome personalizado.',
      'Evolution API: conectar via QR Code exibido no modal — basta escanear com o WhatsApp.',
      'Evolution API: status da conexão em tempo real (Conectado, Desconectado, Aguardando QR).',
      'Evolution API: reiniciar, desconectar e excluir instância.',
      'Evolution API: endpoints de envio de texto e mídia (imagem, vídeo, documento) prontos para integração com campanhas.',
      'Página Sobre: e-mail de contato removido.',
    ],
  },
  {
    version: '0.22.3',
    date: '2026-03-17',
    changes: [
      'Relatórios > Engajamento (Pessoas e Auxiliares): frequência agora considera apenas eventos fechados.',
      'Pessoas > Listagem: "Frequência 90 dias" agora considera apenas eventos fechados.',
    ],
  },
  {
    version: '0.22.2',
    date: '2026-03-16',
    changes: [
      'Dashboard Auxiliar > Presença: cards de estatísticas (Presentes, Organistas, Músicos, Violeiros) só aparecem após confirmar presença.',
      'Dashboard Auxiliar > Presença: filtro "Minhas Pessoas" renomeado para "Minhas".',
      'Dashboard Auxiliar > Presença: modo "Rápida" inicia desmarcado por padrão.',
      'Dashboard Auxiliar > Presença: listagem de eventos ordenada por data crescente (mais próximo primeiro).',
      'Dashboard Auxiliar > Presença: listagem de eventos agora exibe próximos 7 dias.',
      'Dashboard Auxiliar > Presença: removido badge "Hoje" da listagem de eventos.',
      'Dashboard Auxiliar > Presença: alinhamento corrigido entre sidebar e card do evento.',
    ],
  },
  {
    version: '0.22.1',
    date: '2026-03-16',
    changes: [
      'Dashboard Auxiliar > Presença: modal de confirmação ao marcar "Ausente" — avisa quais funções serão redirecionadas antes de confirmar.',
      'Dashboard Auxiliar > Presença: clicar em "Presente" quando já está presente desmarca e volta para "Aguardando".',
      'Dashboard Auxiliar > Presença: listagem de eventos agora exibe os próximos 7 dias (além dos passados).',
      'Dashboard Auxiliar > Menu: novo botão "Ajuda" — wizard interativo com 9 passos explicando todas as funcionalidades do módulo.',
      'Fechar Evento: escala com atribuições é automaticamente confirmada ao fechar, sem bloquear o fecho.',
      'Responsividade: header do evento redesenhado — nome sem truncamento, badges de função em linha própria, botões com flex-wrap.',
    ],
  },
  {
    version: '0.22.0',
    date: '2026-03-16',
    changes: [
      'Escalas: insígnia de líder (estrela) agora aparece nos badges de substituição quando a liderança foi transferida (ex: "Renatinha → Isa" com estrela).',
      'Dashboard Auxiliar > Presença: funções redirecionadas por ausência agora aparecem com badge riscado e cinza (tooltip com destino).',
      'Dashboard Auxiliar > Presença: novo botão "Escala" no header do evento — abre modal de visualização por auxiliar.',
      'Modal "Escala do Evento": listagem por auxiliar com bolinha de status (presente/ausente/aguardando), nome e badges de função inline.',
      'Modal "Escala do Evento": agrupamento por Meninas (rosa) e Meninos (azul), com badges coloridos por género.',
      'Modal "Escala do Evento": accordion — género do auxiliar logado aparece primeiro (expandido), o outro fica colapsado.',
      'Modal "Escala do Evento": ausentes ordenados por último na listagem.',
      'Modal "Escala do Evento": layout responsivo — no mobile, nome e funções em linhas separadas com bolinha centralizada.',
      'Histórico: substituições agora indicam "(líder)" quando a pessoa substituída era responsável pela função.',
      'Dashboard Auxiliar > Presença: listagem de pessoas só aparece após o auxiliar confirmar presença.',
      'Dashboard Auxiliar: botão "Minhas Escalas" no header agora redireciona para a aba Presença.',
      'Responsividade: header do evento redesenhado — nome sem truncamento, badges de função em linha própria, botões com flex-wrap.',
    ],
  },
  {
    version: '0.21.0',
    date: '2026-03-15',
    changes: [
      'Configurações > Escalas: menu reorganizado em 3 submenus — Recitativos, Outros Serviços e Revezamentos.',
      'Recitativos e Outros Serviços: listagem agora agrupada por Meninos e Meninas.',
      'Nova Função: ao criar via submenu Recitativos ou Outros, o tipo já vem pré-selecionado (sem seletor).',
      'Pessoas > Editar Pessoa (auxiliar): nova aba "Sob Cuidado" mostra as pessoas associadas à fila do auxiliar, com faixa etária e co-auxiliares.',
      'Sob Cuidado: clique no botão ">" abre modal de visualização rápida com dados da pessoa.',
      'Dashboard Auxiliar > Minhas Pessoas: agora lista apenas as pessoas da fila de recitativo onde o auxiliar está atribuído, agrupadas por função.',
    ],
  },
  {
    version: '0.20.0',
    date: '2026-03-15',
    changes: [
      'Escalas: corrigido bug onde a lista de auxiliares de recitativos não atualizava visualmente após salvar no modal "Gerir Escala".',
      'Escalas: botões "Fechar Evento" e "Gerir Escalas" no modal de editar evento agora são icon-only com tooltips.',
      'Rotação de Recitativos: configuração de ciclo (duração em meses) movida das funções individuais para o modal de rotação, como configuração global.',
      'Rotação de Recitativos: countdown visual mostrando tempo decorrido desde a última rotação, com barra de progresso e indicador de ciclo vencido.',
      'Rotação de Recitativos: cores da listagem e botões mudam de azul para rosa quando "Meninas" está selecionado.',
      'Rotação de Recitativos: ao aplicar rotação antes do ciclo completo, modal de confirmação avisa que o ciclo ainda está em andamento.',
    ],
  },
  {
    version: '0.19.0',
    date: '2026-03-13',
    changes: [
      'Notificações de presença/ausência: ao marcar ausência e um substituto ser escolhido, o admin e o substituto recebem notificação.',
      'Notificações de retorno: quando alguém que estava ausente confirma presença, o admin é notificado.',
      'Novo dropdown de notificações com tooltip de detalhes, ícones por tipo e botão "Limpar tudo".',
      'Marcar notificação como lida individualmente ou todas de uma vez.',
      'Ícones informativos (?) adicionados em Links, Atribuições, Motivos de Inativação e Tipos de Evento.',
    ],
  },
  {
    version: '0.18.0',
    date: '2026-03-13',
    changes: [
      'Novo sistema de Revezamento de Funções — permite alternar automaticamente funções entre eventos (ex: Grupo A e Grupo B trocam de funções a cada evento).',
      'Configurações: nova secção "Revezamentos" na aba de Escalas de Serviço, com CRUD completo (criar, editar, excluir grupos de revezamento).',
      'Revezamentos: cada grupo define Lado A e Lado B com funções que se alternam automaticamente.',
      'Revezamentos: badge visual na lista de funções indicando grupo e lado (ex: "Orações · Lado A").',
      'Algoritmo de sugestão: integração com revezamentos — exclui automaticamente as funções do lado inativo com base no último evento do mesmo tipo.',
      'Geração automática de escala: também respeita os grupos de revezamento ativos.',
    ],
  },
  {
    version: '0.17.0',
    date: '2026-03-13',
    changes: [
      'Novo link público "Atualizar Dados" — permite que membros atualizem seus dados cadastrais com verificação por nome, data de nascimento e nome da mãe.',
      'Link "Atualizar Dados" criado automaticamente no Linktree para todas as igrejas.',
      'WhatsApp: destinatários agora agrupados em 3 categorias — WhatsApp Próprio, do Pai e da Mãe.',
      'WhatsApp: pais/mães com mesmo número para múltiplos filhos aparecem uma única vez (ex: "José Silva (pai de Ana, Maria)").',
      'WhatsApp: busca unificada por nome da pessoa, pai, mãe ou número de telefone.',
      'Slug do link de atualização gerado automaticamente quando ausente (sob demanda).',
    ],
  },
  {
    version: '0.16.0',
    date: '2026-03-13',
    changes: [
      'Minhas Escalas: botões Presente/Ausente agora funcionam como toggle — clicar novamente desmarca e volta para "Aguardando".',
      'Minhas Escalas: ao marcar ausência, o log de histórico agora registra quem foi atribuído como substituto em cada função.',
      'Minhas Escalas: ao marcar ausência, as funções reatribuídas são removidas da secção "Funções e Atribuições".',
      'Minhas Escalas: ações de desmarcar registradas no histórico como "Desmarcou Presente" ou "Desmarcou Ausente".',
      'Escalas: algoritmo de substituição agora exclui auxiliares que marcaram ausência no evento.',
      'Escalas: algoritmo de substituição não exclui mais rigidamente quem já está escalado noutras funções — usa penalidade de prioridade como fallback.',
      'Dashboard: card "Eventos Abertos" agora ordenado por data crescente (mais próximos primeiro) e exibe badge com o tipo do evento.',
      'Links: URL de cadastro público alterada de /cadastro/slug para /pessoas/slug.',
      'Links: acesso ao endereço antigo /cadastro/slug agora exibe "Página não encontrada".',
    ],
  },
  {
    version: '0.15.0',
    date: '2026-03-12',
    changes: [
      'Escalas: botão informativo (?) no card de Escala de Serviço — modal explicativo sobre sugestão automática, revezamento, edição manual, status "Confirmada" e pessoas elegíveis.',
      'Escalas: espaçamento reduzido entre o header e o botão "Gerar sugestões".',
      'Escalas: correção do dropdown de seleção de pessoas — agora abre para cima quando posicionado na parte inferior do modal, sem ser cortado.',
      'Dashboard Auxiliar: novo botão "Minhas Escalas" no header (ícone clipboard) — visível também no celular, ao lado do sino de notificações.',
      'Minhas Escalas: modal com listagem colapsável dos próximos eventos abertos onde o auxiliar foi escalado.',
      'Minhas Escalas: ao expandir um evento, exibe a fila/atribuição do auxiliar e as funções de serviço atribuídas, tudo inline.',
      'Minhas Escalas: apenas eventos com tipo que tenha "Permitir gerenciamento de serviços" e "Tem contagem de recitativos" são listados.',
      'Minhas Escalas: busca inteligente de pessoa vinculada — agora funciona também por correspondência de nome quando não há vínculo direto por e-mail ou ID.',
      'Correção: formatação de data (fmtDate) agora suporta datas com espaço como separador (ex: "2026-03-08 09:30").',
    ],
  },
  {
    version: '0.14.0',
    date: '2026-03-12',
    changes: [
      'Novo módulo: Escalas de Serviço — organize o revezamento automático de auxiliares nos eventos.',
      'Configurações: Novo complemento "Escalas de Serviço" ativável em Complementos.',
      'Configurações: CRUD de Funções de Serviço (nome, qtd. meninos/meninas, elegibilidade por gênero e atribuição).',
      'Tipos de Evento: Nova flag "Permitir gerenciamento de serviços" com tooltip explicativo.',
      'Eventos: Card "Escala de Serviço" no modal do evento com sugestão automática baseada em histórico de revezamento.',
      'Escalas: Algoritmo justo que prioriza quem serviu menos e evita repetições consecutivas.',
      'Escalas: Edição manual de escalas — adicionar/remover auxiliares com busca por nome.',
    ],
  },
  {
    version: '0.13.5',
    date: '2026-03-12',
    changes: [
      'Reuniões: editor de ata substituído por TipTap — agora com títulos (H1/H2/H3), cores de texto, destaque, sublistas aninhadas (Tab), checklist, alinhamento, citações, tabelas, links e linha horizontal.',
      'Reuniões: destaque de texto (highlight) agora tem cantos arredondados e padding suave.',
      'Eventos: listagem agora ordena abertos (data crescente) primeiro, seguidos dos fechados (data decrescente).',
      'Presença: sidebar de eventos ordenada por data crescente.',
      'Telefone: ao colar número com código de país (+55), o sistema remove automaticamente o prefixo e formata corretamente. Ex: +55 11 94714-9818 → (11) 94714-9818.',
    ],
  },
  {
    version: '0.13.4',
    date: '2026-03-11',
    changes: [
      'WhatsApp: busca de destinatários agora funciona por nome e número de telefone (com ou sem formatação).',
      'WhatsApp: destinatários mostram bolinha de status: verde (enviado), vermelha (erro) e cinza (pendente).',
      'WhatsApp: destinatários já enviados ficam desmarcados ao editar a campanha.',
      'WhatsApp: campanhas prontas agora podem ser editadas.',
      'WhatsApp: mensagens pendentes são enviadas em ordem alfabética.',
    ],
  },
  {
    version: '0.13.3',
    date: '2026-03-11',
    changes: [
      'WhatsApp: botões de ação na listagem de campanhas agora exibem apenas ícones (mais limpo e compacto).',
      'WhatsApp: apenas o botão "Total de enviados" mantém o texto com a quantidade (ex: 2/5).',
      'WhatsApp: novo status "Cancelada" com botões Aprovar, Editar e Excluir.',
      'WhatsApp: filtro "Canceladas" adicionado na barra lateral.',
      'WhatsApp: módulo WhatsApp agora é um complemento ativável em Configurações > Complementos.',
      'WhatsApp: novo botão "Como funciona a extensão?" com modal explicativo detalhado (instalação, configuração, envio e dicas).',
      'WhatsApp: botões de formatação (B, I, S) no campo de mensagem para negrito, itálico e riscado.',
      'WhatsApp: variáveis inserem no cursor e devolvem o foco ao campo de mensagem.',
      'WhatsApp: "Configurações de Envio" agora começa colapsado no modal de campanha.',
      'WhatsApp: corrigido bug "Invalid Date" na listagem de campanhas.',
      'WhatsApp: corrigido erro ao editar campanha (variável não declarada).',
      'WhatsApp: botão "Voltar para Rascunho" agora usa endpoint dedicado.',
      'WhatsApp: botão "Cancelar" agora usa endpoint dedicado.',
      'WhatsApp: extensão Chrome v1.3.9 — botão "Iniciar Envio" agora é ícone play alinhado à direita, inline com o nome da campanha.',
    ],
  },
  {
    version: '0.13.1',
    date: '2026-03-10',
    changes: [
      'WhatsApp: extensão Chrome v1.0.5 - corrigido envio de mensagens (automação direta no WhatsApp Web sem navegação externa).',
      'WhatsApp: adicionada injeção automática do content script e verificação de conectividade.',
      'WhatsApp: melhorada robustez com múltiplos seletores de fallback e métodos de input.',
      'WhatsApp: adicionada variação aleatória no delay entre mensagens para evitar detecção.',
      'WhatsApp: adicionado mecanismo de retry (até 2 tentativas) por mensagem.',
    ],
  },
  {
    version: '0.13.0',
    date: '2026-03-10',
    changes: [
      'WhatsApp: módulo de envio de mensagens em massa via WhatsApp Web.',
      'WhatsApp: criação de campanhas com mensagem personalizada usando variáveis ({primeiro_nome}, {nome_completo}, {idade}, etc.).',
      'WhatsApp: filtros de destinatários por sexo, batizado, faixa etária e aniversariantes.',
      'WhatsApp: configurações de delay entre mensagens, pausa automática a cada X contatos e duração da pausa.',
      'WhatsApp: extensão Chrome para automação de envio via WhatsApp Web com controles de Iniciar, Pausar, Retomar e Cancelar.',
    ],
  },
  {
    version: '0.12.3',
    date: '2026-03-10',
    changes: [
      'Sobre: página pública /sobre criada para verificação do Google OAuth — identificação do sistema, funcionalidades, dados solicitados, segurança e contato.',
      'Rodapé: "Informações do Projeto" substituído por link "Sobre" que abre a página /sobre.',
      'Rodapé: adicionado nas páginas Sobre, Termos de Uso e Política de Privacidade (completo com versão e links).',
      'Contato: e-mail de suporte adicionado na página Sobre.',
    ],
  },
  {
    version: '0.12.2',
    date: '2026-03-10',
    changes: [
      'Termos de Uso: página dedicada /termos com 20 seções — responsabilidades por papel, condutas proibidas, integrações, propriedade intelectual, limitação de responsabilidade, resolução de conflitos.',
      'Política de Privacidade: página dedicada /politica-de-privacidade com 16 seções — LGPD completa, bases legais, direitos do titular, dados de menores, transferência internacional, incidentes de segurança.',
      'Rodapé: links para Termos de Uso e Política de Privacidade abrem em páginas dedicadas.',
      'Configurações > Complementos: tooltip informativo adicionado em "Solicitação de Visitas".',
    ],
  },
  {
    version: '0.12.1',
    date: '2026-03-10',
    changes: [
      'Google Calendar: integração de sincronização de aniversários — cria uma agenda exclusiva no Google Agenda com eventos recorrentes para cada membro.',
      'Google Calendar: descrição do evento inclui informações da pessoa (idade, gênero, telefones, fila, batizado, músico).',
      'Google Calendar: ao desconectar, a agenda de aniversários é excluída automaticamente do Google.',
      'Configurações > Complementos: ícones padronizados (#2662eb) e botões sutis para Conectar, Sincronizar e Desconectar.',
      'Login: redirecionamento automático para /admin, /auxiliar ou /gestor se já houver sessão ativa.',
    ],
  },
  {
    version: '0.12.0',
    date: '2026-03-10',
    changes: [
      'Solic. Visitas (Admin): campo de busca unificado "Pesquise pelo nome ou WhatsApp" — busca por nome exibe dropdown com pessoas, busca por telefone faz expansão familiar.',
      'Solic. Visitas (Admin): ao selecionar pessoa pelo nome, preenche o telefone e exibe cards de família automaticamente.',
      'Solic. Visitas (Admin): se não encontrar ninguém, libera campos Nome e WhatsApp para cadastro manual.',
      'Solic. Visitas: responsividade melhorada — badge de status na linha inferior, botões menores no mobile.',
    ],
  },
  {
    version: '0.11.9',
    date: '2026-03-10',
    changes: [
      'Pessoas: botão "Solicitar Visita" adicionado na listagem — abre o modal de criação de visita com o WhatsApp da pessoa pré-preenchido e busca familiar automática.',
      'Solic. Visitas: pessoas encontradas pela expansão familiar agora exibem "Pessoa relacionada" como indicação.',
    ],
  },
  {
    version: '0.11.8',
    date: '2026-03-10',
    changes: [
      'Solic. Visitas: busca familiar por telefone — ao digitar um número, o sistema encontra todas as pessoas que compartilham telefones em comum (próprio, pai ou mãe), agrupando famílias automaticamente.',
      'Solic. Visitas: busca familiar aplicada também no formulário público de solicitação de visita.',
    ],
  },
  {
    version: '0.11.7',
    date: '2026-03-10',
    changes: [
      'Solic. Visitas: modal de agendamento exibe apenas tipos de evento com "Permite associar pessoa" ativo.',
      'Solic. Visitas: toast de orientação ao tentar agendar sem nenhum tipo de evento configurado com "Permite associar pessoa".',
      'Perguntas: listagem atualizada automaticamente ao abrir a aba.',
      'Cadastro Público: corrigido erro 403 ao submeter formulário de cadastro via link público.',
      'Configurações: slug de visitas gerado automaticamente ao ativar o módulo "Solic. Visitas".',
      'Tipos de Evento: ícone "Permite associar pessoa" exibido na listagem.',
    ],
  },
  {
    version: '0.11.6',
    date: '2026-03-10',
    changes: [
      'Eventos: associação de múltiplas pessoas a um evento — seletor multi-pessoa com badges removíveis e campo de busca no modal de agendamento.',
      'Solic. Visitas: ao agendar evento a partir de uma visita, todas as pessoas da visita são pré-selecionadas no evento.',
      'Solic. Visitas: nome do evento gerado automaticamente a partir dos primeiros nomes das pessoas (ex: "Eduardo, Michellen e Antonella").',
      'Solic. Visitas: nome da visita gerado automaticamente (mesmo formato) ao criar via link público.',
      'Solic. Visitas: listagem atualizada automaticamente ao abrir a aba.',
      'Histórico da Pessoa: visitas associadas agora aparecem no histórico com nome e status.',
      'Eventos: listagem exibe tooltip com todos os nomes das pessoas associadas.',
    ],
  },
  {
    version: '0.11.3',
    date: '2026-03-09',
    changes: [
      'Auditoria: redesign completo com filtros por módulo, tipo de ação e utilizador, expand/collapse com agrupamentos e ícones por entidade.',
      'Auditoria: cobertura total de logs — todo CRUD do sistema agora registra auditoria, incluindo votações, links, perguntas, visitas, anotações e motivos de inativação.',
      'Auditoria: exclusões agora salvam os dados do registro excluído para consulta futura.',
      'Auditoria: correção do church_id nos logs (870 registros migrados) — logs agora visíveis no relatório.',
      'Auditoria: botão de atualizar listagem e recarga automática ao abrir o modal.',
      'Auditoria: registro de login de admins e auxiliares.',
      'Histórico da Pessoa: campos com nomenclatura legível e diff de alterações para todas as ações de atualização.',
      'Timezone: todas as datas e horas do sistema agora exibem em America/Sao_Paulo.',
      'Badges: removido hover de todos os badges do sistema.',
      'Administradores: modal de confirmação ao excluir e validação de email no cadastro.',
      'Administradores: aviso informativo no modal de cadastro sobre acesso via Google.',
    ],
  },
  {
    version: '0.11.2',
    date: '2026-03-09',
    changes: [
      'Solic. Visitas: botão "Excluir Agendamento" no modal de edição de evento — exclui o evento vinculado e reverte a visita para Pendente.',
      'Solic. Visitas: ícone de status na listagem substituído por HandHelping em círculo colorido (Amarelo = Pendente, Azul = Agendada, Verde = Realizada).',
      'Páginas Públicas: tela "Página não encontrada" padronizada em todas as páginas (Linktree, Cadastro, Visitas e Perguntas) com layout unificado.',
    ],
  },
  {
    version: '0.11.1',
    date: '2026-03-09',
    changes: [
      'Histórico da Pessoa: nova aba "Histórico" no modal de editar pessoa, com timeline visual de todas as ações desde o cadastro.',
      'Histórico inclui: data de cadastro, aprovação, atualizações de dados, migrações de fila e todas as presenças em eventos.',
      'Histórico retroativo: mesmo para pessoas cadastradas antes do sistema de auditoria, exibe dados derivados (created_at, status, presenças).',
      'Para atualizações de dados, exibe os campos alterados com valor anterior e novo.',
    ],
  },
  {
    version: '0.11.0',
    date: '2026-03-09',
    changes: [
      'Eventos Recorrentes: novo recurso para configurar recorrência nos Tipos de Evento (Configurações), com dia da semana, horário e frequência (semanal/quinzenal).',
      'Eventos recorrentes são criados automaticamente ao abrir o dashboard: até 60 min antes do horário previsto, ou retroativamente até 5 dias após a data.',
      'Badge "Recorrente" na listagem de Tipos de Evento e badge "Automático" (com tooltip detalhado) na listagem de Eventos.',
      'Ícones nos badges de configuração dos Tipos de Evento (Presidência, Participantes, Músicos, Recitativos, Ministério, Reuniões, Recorrente) com tooltip.',
      'Modal de eventos por pessoa: filtro Presentes/Ausentes com contagem.',
      'Modal de eventos por pessoa: botão para ver todos os presentes de cada evento.',
      'Modal de eventos: navegação com seta de voltar entre lista de eventos e lista de presentes.',
      'Botão de visualizar eventos nos relatórios visível apenas para administradores.',
      'Relatório de engajamento no dashboard auxiliar agora exibe todas as pessoas, sem filtro por género.',
      'Aba Pessoas agora rebusca dados (incluindo pendentes) ao ser clicada.',
      'Correção na exibição de datas com horário (formato dd/mm/YYYY HH:mm) para eventos automáticos.',
    ],
  },
  {
    version: '0.10.2',
    date: '2026-03-09',
    changes: [
      'UI: removido cursor de interrogação (?) de todos os tooltips do sistema — o ponteiro do rato agora permanece padrão ao passar sobre elementos com tooltip.',
    ],
  },
  {
    version: '0.10.1',
    date: '2026-03-09',
    changes: [
      'Marcação rápida: novo toggle "Rápida" na aba Presença (Admin e Auxiliar) — quando ativo, limpa a busca e foca no campo após marcar presença.',
      'Correção: listagem "Minhas Pessoas" no dashboard auxiliar agora exibe todas as pessoas das filas associadas (antes mostrava apenas pessoas com fila manual por erro na função calcAge).',
      'Correção: adicionada função calcAgeNum para cálculos numéricos de idade, corrigindo comparações que falhavam silenciosamente.',
      'Correção: função getEffectiveFilaId no dashboard auxiliar agora verifica género da fila corretamente.',
      'Tooltip detalhado na aba Auxiliares (Admin): ao passar o mouse na contagem de pessoas, exibe os nomes agrupados por atribuição.',
    ],
  },
  {
    version: '0.10.0',
    date: '2026-03-09',
    changes: [
      'Recitativos: seção de contagem ao fechar evento agora separada por Meninas e Meninos, exibindo apenas filas do tipo Recitativo Normal e Individual (oração excluída).',
      'Recitativos: corrigida duplicação do campo "Individual" — agora aparece apenas uma vez por coluna.',
      'Recitativos: correção aplicada em Admin (Eventos e Presença) e Auxiliar.',
      'Busca sem acentos: todas as buscas do sistema agora ignoram acentuação (ex: digitar "Livia" encontra "Lívia").',
      'Busca aplicada em: Pessoas, Presença, Eventos, Auxiliares, Pendentes, Votações, Reuniões, Perguntas e Dashboard Auxiliar.',
      'Presença: ao marcar presença ou ausência, o campo de busca é limpo automaticamente e recebe foco para digitar o próximo nome.',
    ],
  },
  {
    version: '0.9.9',
    date: '2026-03-08',
    changes: [
      'Novo relatório: Migrações Futuras — previsão de mudanças de atribuição baseada na data de nascimento, com filtros por período (1, 3, 6, 12 meses) e atribuição.',
      'Novo relatório: Histórico de Migrações — registro automático de todas as mudanças de atribuição, com filtros por mês e atribuição.',
      'Verificação automática de migrações: a cada login, o sistema compara a atribuição atual de cada pessoa com a última registrada e grava a alteração.',
      'Cards resumo nas Migrações Futuras: visão rápida de quantas pessoas entram e saem de cada atribuição no período selecionado.',
      'Filtros de atribuição nos relatórios de migração agrupados por Meninas e Meninos, ordenados por tipo e nome.',
      'Correção: filtro por atribuição na aba Presenças agora usa a mesma lógica de género + idade da aba Pessoas.',
      'Correção: novas igrejas são criadas sem dados padrão (atribuições, motivos e tipos de evento).',
      'Correção: filtro de atribuições nos relatórios de migração agora aparece corretamente no dashboard do Auxiliar.',
    ],
  },
  {
    version: '0.9.8',
    date: '2026-03-08',
    changes: [
      'Links do Sistema: "Cadastro via Link" migrado dos Complementos para a lista de Links como item reordenável com badge "Sistema", toggle, edição de cores/ícone e Termo de Uso integrado.',
      'Links do Sistema: "Perguntas" — ao ativar o módulo nos Complementos, cria automaticamente um link do sistema na lista de Links. Ao desativar, o link é ocultado.',
      'Links do Sistema: botão de editar URL (slug) disponível diretamente na listagem para links do sistema.',
      'Links do Sistema: links do sistema não podem ser excluídos nem duplicados.',
      'Páginas Públicas: Cadastro, Perguntas e Linktree agora respeitam as configurações visuais de Configurações > Links > Configuração da Página (fundo, fonte, cores de texto, cores de ícone).',
      'Páginas Públicas: botões usam cor de fundo = "Fundo do Ícone" e cor da fonte = "Cor do Ícone" das configurações de Links.',
      'Páginas Públicas: barra de progresso, etapas do wizard e todos os ícones do Cadastro usam as cores configuradas.',
      'Páginas Públicas: título do navegador agora exibe "CCBRJM" em todas as páginas públicas.',
      'Páginas Públicas: se não houver nenhum link ativo, a página do Linktree exibe "Página não encontrada".',
      'Páginas Públicas: todos os links do Linktree agora abrem em nova janela.',
      'Perguntas: título e descrição da página pública atualizados ("Envio de Perguntas" com texto explicativo).',
      'Cadastro: se idade < 14, sempre pergunta se possui WhatsApp próprio (mesmo que já informado na fase inicial).',
      'Complementos: título alterado de "Addons" para "Complementos".',
      'Complementos: botão "Editar URL" de Perguntas substituído por ícone de informação com tooltip direcionando para Links.',
      'UI: ícone "Configurações da Página" trocado para engrenagem.',
      'UI: ícone "Church" removido do seletor de ícones de links.',
      'UI: URL oculta na edição e na listagem para links do sistema (mostra descrição em vez da URL).',
      'Header: botões de copiar link Cadastro e Perguntas removidos; botão de link agora abre Configurações > Links.',
      'Header: backup visível apenas para utilizadores com role "gestor".',
      'Rodapé: ícones adicionados (coração, código, info, escudo).',
      'Rodapé: estilo unificado em todas as páginas públicas.',
    ],
  },
  {
    version: '0.9.7',
    date: '2026-03-08',
    changes: [
      'Correção crítica: erro 401 (Não Autorizado) ao criar, editar ou excluir links no módulo Configurações > Links em produção.',
      'Causa: chamadas de API no módulo de Links usavam uma URL fixa do ambiente de build em vez da origem atual do navegador, impedindo o envio dos cookies de sessão.',
      'Correção aplicada também à página pública de links (/l/{slug}).',
    ],
  },
  {
    version: '0.9.6',
    date: '2026-03-07',
    changes: [
      'Links: opções de fundo para a página pública — Cor Sólida, Gradiente personalizado (2 cores + direção) e 12 Temas prontos (Lavanda, Rose, Céu, Sálvia, Areia, Pérola, Lilás, Oceano, Pêssego, Menta, Crepúsculo, Noite).',
      'Links: personalização de cor do ícone e cor de fundo do ícone da página.',
      'Links: configurações da página reorganizadas em grupos visuais (Geral, Ícone, Fundo da Página).',
      'Links: descrição alterada para textarea; Título da Página renomeado.',
      'Links: botão para duplicar link na listagem (substitui o toggle ativar/inativar que já estava no editar).',
      'Links: edição do link reorganizada em 3 grupos (Geral, Design, Como vai ficar).',
      'Links: URL normalizada automaticamente — pode digitar apenas o domínio (google.com) sem https://.',
      'Links: slug independente para o Linktree (separado do slug do cadastro) com botão de editar e gerar aleatório.',
      'Links: modal de confirmação ao excluir um link.',
      'Backup: coleções Links e Config. da Página de Links adicionadas ao módulo de backup.',
      'Backup: exportação limpa — sem IDs internos, church_id, deleted ou created_at. Apenas conteúdo.',
      'Backup: importação gera novos IDs para cada registro e atribui à igreja logada automaticamente.',
      'Tutorial: modal de onboarding agora abre apenas uma vez por sessão (corrigido bug que reabria ao trocar de aba).',
      'Correção: erro 403 ao salvar ata de reunião usando a funcionalidade Personificar.',
    ],
  },
  {
    version: '0.9.5',
    date: '2026-03-07',
    changes: [
      'Novo módulo: Links (Linktree) — página pública personalizável em /l/{slug} com CRUD completo em Configurações > Links.',
      'Personalização de links: ícone, cor do botão/fonte/borda, border-radius, tipo e tamanho da borda.',
      'Configurações da página de links: nome da igreja, bio, ícone, cor de fundo, cores de fonte e família tipográfica.',
      'Seletor de ícones com busca: acesso a todos os ícones do lucide-react (~2600+).',
      'Botões para copiar URL, abrir página pública e reordenar links.',
      'Footer minimalista na página pública de links (apenas Informações e Política de Privacidade).',
      'Correção: campos WhatsApp do Pai e Mãe agora são salvos ao criar ou editar pessoa pelo admin.',
      'Correção: dashboard do gestor agora desconsidera registros com soft delete.',
      'Correção: slug da igreja agora disponível no endpoint /api/settings.',
    ],
  },
  {
    version: '0.9.4',
    date: '2026-03-07',
    changes: [
      'Atualização de cadastro via link público: fluxo seguro com verificação por SMS (WhatsApp > SMS > Código > Seleção de perfil > Edição).',
      'Cache de verificação SMS: números validados nos últimos 30 minutos não precisam de novo SMS.',
      'Busca de contactos aprimorada: normalização por dígitos em Python para encontrar correspondências em whatsapp, whatsapp_pai e whatsapp_mae independentemente da formatação.',
      'Aprovação de atualizações: painel administrativo para aprovar ou rejeitar atualizações de perfil enviadas pelo link público.',
      'Correção: campos WhatsApp do Pai e WhatsApp da Mãe agora são salvos corretamente ao criar ou editar uma pessoa pelo painel admin.',
      'Campo WhatsApp oculto no formulário de cadastro quando já informado na etapa inicial.',
      'Cooldown de 3 minutos para reenvio de SMS com temporizador visível.',
      'Código SMS com 6 campos de input individuais para melhor usabilidade.',
      'Melhorias de espaçamento no formulário de cadastro público e na tela de seleção de perfis.',
    ],
  },
  {
    version: '0.9.3',
    date: '2026-03-06',
    changes: [
      'Módulo de Backup: adicionadas coleções Reuniões, Pautas, Tarefas e Votações.',
      'Backup: validação de estrutura do JSON antes da importação (campos obrigatórios verificados).',
      'Backup: modal de pré-visualização com todos os dados do JSON e scroll horizontal.',
      'Backup: cada registro mostra o status "Novo" ou "Atualizar" conforme já exista no banco.',
      'Backup: tratamento de JSON vazio (aviso informativo em vez de erro).',
      'Backup: removida coleção "Auxiliares" inexistente.',
      'Votações em Reuniões: card só aparece se o módulo Votações estiver habilitado nos Complementos.',
      'Responsividade: abas Votações e Reuniões adaptadas para dispositivos móveis (filtros horizontais, botões compactos, headers empilháveis).',
      'Atribuição de tarefas: listagem agora usa dados dos utilizadores (user_id) em vez de pessoas (pessoa_id).',
    ],
  },
  {
    version: '0.9.2',
    date: '2026-03-06',
    changes: [
      'Notificações de tarefas pendentes: tarefas atribuídas ao utilizador agora aparecem no sino de notificações.',
      'Tarefas sem prazo notificam imediatamente; com prazo, notificam a partir da data definida.',
      'Notificações de tarefas desaparecem automaticamente quando a tarefa é concluída.',
      'Listagem de notificações unificada (tarefas e eventos no mesmo formato, sem agrupamento).',
      'Listagem de responsáveis (tarefas) agora usa a aba Auxiliares, com ordenação alfabética.',
      'Exclusão de reunião agora também exclui votações vinculadas.',
      'Correção: auxiliares podem adicionar pautas em reuniões "em andamento" (antes só era permitido em "agendada").',
      'Correção: pautas de auxiliares no dashboard admin sem diferenciação de cor.',
      'Texto da ata no dashboard auxiliar corrigido.',
      'Removido placeholder do campo de busca na aba Reuniões.',
    ],
  },
  {
    version: '0.9.1',
    date: '2026-03-06',
    changes: [
      'Tipos de Evento agrupados por "Espiritual" e "Material" em Configurações > Tipos de Evento.',
      'Layout padronizado em todas as listagens de Configurações (Administradores, Atribuições, Tipos de Evento, Motivos) com cards arredondados e títulos de grupo.',
      'Menu "Atualizações" (changelog) agora abre como modal independente e visível apenas para o perfil Gestor.',
      'Datas do changelog corrigidas para formato sequencial e label "Publicação em".',
    ],
  },
  {
    version: '0.9.0',
    date: '2026-03-06',
    changes: [
      'Novo módulo de Backup e Restauração em Configurações > Backup: exportar e importar dados de 6 coleções (Pessoas, Auxiliares, Eventos, Tipos de Evento, Atribuições, Motivos) em formato JSON.',
      'Auxiliares agora podem ser vinculados a múltiplas atribuições simultaneamente (multi-select com checkboxes).',
      'Correção na contagem de pessoas por atribuição: agora considera corretamente o gênero e a faixa etária de cada atribuição.',
      'Dashboard: card "Pessoas por Atribuições" (antigo "Distribuição por Fila") agrupado por Meninos e Meninas, com contagem por faixa etária + gênero.',
      'Dashboard: card "Faixa Etária" agrupado por Meninos e Meninas com novas faixas: 0-5, 6-11, 12-15, 16-18, 19-24, 25+.',
      'Dashboard: atribuições ordenadas por tipo (Rec. Normal, Individual, Oração) e nome.',
      'Tipos de Evento: nome limitado a 16 caracteres com contador visual.',
      'Correção na auto-atribuição de fila: prioriza filas do tipo "Recitativo Normal" antes de "Individual" e "Oração".',
    ],
  },
  {
    version: '0.8.1',
    date: '2026-03-06',
    changes: [
      'Presença: seleção automática agora prioriza o último evento em aberto (não seleciona eventos fechados).',
      'Votações Admin: botões "Enviar", "Encerrar" e "Respostas" com novo layout outline e posicionados por último.',
      'Votações Admin: contagem de respostas exibida na listagem, igual ao painel Auxiliar.',
      'Votações Auxiliar: botão "Resultados" com novo layout outline alinhado ao padrão do Admin.',
      'Header Auxiliar: botão "Link Perguntas" adicionado, igual ao painel Admin.',
    ],
  },
  {
    version: '0.8.0',
    date: '2026-03-05',
    changes: [
      'Votação anônima: novo toggle para ocultar a identidade dos respondentes nos resultados.',
      'Edição de respostas: auxiliares podem alterar a sua resposta enquanto a votação estiver aberta.',
      'Reabertura de votações: administradores podem reabrir votações encerradas (voltam ao estado de rascunho).',
      'Exclusão de votações em qualquer status pelo administrador.',
      'Resultados em tempo real: o modal de resultados atualiza automaticamente a cada 5 segundos.',
      'Modal de resultados unificado entre Admin e Auxiliar com gráficos de barras, percentagens e lista de respostas individuais.',
      'Redesign completo do formulário de criação e edição de votações no painel Admin.',
      'Layout de 2 colunas com filtros na barra lateral na aba de votações do Auxiliar.',
      'Refinamento de badges de status e filtros nas abas de votações.',
      'Correção de erro ao responder votações como utilizador impersonado.',
    ],
  },
  {
    version: '0.7.0',
    date: '2026-03-05',
    changes: [
      'Novo módulo de Votações: crie votações com texto ou múltipla escolha, envie aos auxiliares e visualize respostas.',
      'Addon "Votações" em Configurações > Complementos (desabilitado por padrão).',
      'Aba Votações no Dashboard Admin com CRUD completo, filtros por status e visualização de resultados.',
      'Aba Votações no Dashboard Auxiliar para responder votações pendentes.',
      'Correção de acentuação nos complementos existentes (módulo, público).',
    ],
  },
  {
    version: '0.6.0',
    date: '2026-03-05',
    changes: [
      'Nova aba Dashboard no painel Auxiliar com visão geral completa',
      'Novos cards no Dashboard: Menos Engajados, Top 10 Instrumentos e Nunca Compareceram',
      'Submenu "Pendentes" na aba Pessoas com sub-filtros inline: Pendentes, Aprovados e Reprovados',
      'Submenu "Manual" para listar pessoas com fila atribuída manualmente',
      'Agrupamento "Gatilhos" e "Filas" na sidebar da aba Pessoas',
      'Remoção da aba Pendências (gestão centralizada em Pessoas)',
      'Badge de pendentes e auto-selecção do submenu Pendentes na aba Pessoas',
      'Botão de visualizar detalhes (olho) nos cadastros pendentes',
      'Correção do bug de impersonate: sessão do admin restaurada automaticamente',
      'Eventos futuros com ícone diferenciado, tooltip e badge "Evento Futuro"',
      'Addon "Aniversariantes" em Configurações > Complementos',
      'Remoção dos cards de estatísticas globais do Dashboard Auxiliar',
      'Campo de busca antes dos filtros nas abas Presença e Pessoas',
      'Badge do tipo de evento após o nome do evento selecionado',
      'Correção da borda indesejada (ring) nos modais',
    ],
  },
  {
    version: '0.5.1',
    date: '2026-03-04',
    changes: [
      'Cards de resumo padronizados com ícones nos painéis do Administrador, Auxiliar e Gestor',
      'Padronização de fuso horário em todo o sistema (datas agora respeitam o horário de Brasília)',
      'Correção na exibição de aniversariantes nascidos no dia 1 do mês',
      'Correção na exibição da faixa etária no Dashboard',
    ],
  },
  {
    version: '0.5.0',
    date: '2026-03-04',
    changes: [
      'Novo formulário de cadastro público em 5 etapas (wizard) com barra de progresso',
      'Verificação automática de duplicados antes de submeter o cadastro (nome, e-mail e WhatsApp)',
      'Campos de WhatsApp do pai e da mãe no cadastro de menores de 14 anos',
      'Seleção automática do último evento realizado na tela de presença',
      'Badge com o tipo de evento exibido ao lado do nome na tela de presença',
      'Relatórios por tipo de evento com gráficos de participação e detalhes',
      'Nova aba Dashboard com visão geral completa para o administrador',
      'Correção do fuso horário nas notificações de eventos pendentes',
      'Rodapé redesenhado com versão dinâmica e data do último deploy',
      'Correções para estabilidade do deploy em produção',
    ],
  },
  {
    version: '0.4.0',
    date: '2026-03-04',
    changes: [
      'Correção de acentuação em todos os textos da aplicação',
      'Gestor pode visualizar o sistema como se fosse um administrador',
      'Rodapé informativo com versão e data em todas as páginas',
      'Listagem de auxiliares agrupada por gênero (Meninos e Meninas)',
      'Histórico de atualizações acessível pelo menu (esta tela)',
      'Melhorias de organização interna para maior estabilidade',
    ],
  },
  {
    version: '0.3.0',
    date: '2026-03-03',
    changes: [
      'Tipos de Evento com prazo de fechamento configurável',
      'Seleção do tipo de evento ao criar ou editar um evento',
      'Notificações para lembrar de eventos que precisam ser fechados',
      'Sino de notificações no cabeçalho da página',
      'Novo layout com menu lateral em vez de abas',
      'Melhorias visuais: ícones, tooltips e espaçamento nos formulários',
      'Exibição da faixa etária ao lado do nome de cada fila',
      'Mensagem de erro amigável para links públicos inválidos',
      'Diversas correções de bugs e melhorias de responsividade',
    ],
  },
  {
    version: '0.2.0',
    date: '2026-03-02',
    changes: [
      'Login seguro com conta do Google',
      'Suporte a múltiplas igrejas (cada igreja com seus dados independentes)',
      'Painel do Gestor para administrar as igrejas cadastradas',
      'Painel do Auxiliar para visualizar eventos e registrar presenças',
      'Configurações: nome da igreja, filas por faixa etária e motivos de saída',
      'Link público para cadastro de novos membros (endereço personalizável)',
      'Módulo de Perguntas (pode ser ativado/desativado nas configurações)',
      'Importação e exportação de pessoas via planilha Excel',
      'Registro de auditoria de todas as ações realizadas no sistema',
      'Relatórios de engajamento: por pessoa, auxiliar, evento, fila e gênero',
      'Lista de aniversariantes com botão para enviar parabéns pelo WhatsApp',
      'Contadores em tempo real na tela de presença',
      'Filtro por gênero na listagem de pessoas',
      'Gestão de administradores nas configurações',
      'Administrador pode visualizar o sistema como se fosse um auxiliar',
    ],
  },
  {
    version: '0.1.0',
    date: '2026-02-26',
    changes: [
      'Lançamento do sistema com cadastro de pessoas, auxiliares e eventos',
      'Controle de presença por evento com marcação individual',
      'Painel administrativo com visão geral em cards de estatísticas',
    ],
  },
];

export const LATEST_VERSION = CHANGELOG[0];
